<template>
    <hts-drawer
        v-model="visible"
        :custom="['header', 'footer']"
        :title="$t('labels.editDocument')"
        :submit="handleSubmitFormEditDocument"
        :undo-enable="true"
        :rules="rules"
        @close="closeOverSide">
        <div class="hts-vehicles-ignore-add-vehicle">
            <div class="hts-vehicles-ignore-add-vehicle__container-body">
                <hts-card :title="$t('labels.generalInformation')">
                    <div
                        class="grid gap-4"
                        :class="columnClass">
                        <hts-form-select
                            v-model="dataFormEditDocument.type"
                            :label="$t('labels.documentType')"
                            required
                            :items="listTypeDocument"
                            key-id="key"
                            key-label="value"
                            :color="props.color"
                            name="documentType"
                            prop="documentType" />
                        <hts-form-input
                            v-model="dataFormEditDocument.fileName"
                            :label="$t('labels.documentFileName')"
                            :color="props.color"
                            name="documentFileName"
                            prop="documentFileName" />
                        <hts-form-file
                            ref="file"
                            v-model="fileDocument"
                            type="file"
                            :label="$t('labels.document')"
                            name="document"
                            prop="document"
                            :file-name="dataFormEditDocument.fileOriginName" />
                        <hts-form-input
                            v-model="dataFormEditDocument.description"
                            :label="$t('labels.description')"
                            :color="props.color"
                            name="description"
                            prop="description" />
                    </div>
                </hts-card>
            </div>
        </div>
    </hts-drawer>
</template>

<script lang="ts" setup>
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 2
  },
  documentInfo: {
    type: Object
  },
  type: {
    type: String,
    default: ''
  }
})

const _initForm = {
  fileName: '',
  type: '',
  description: ''
}

const rules = {
  documentType: 'required',
  expiredDate: 'invalidDateFormat',
  insurancePrice: 'integer',
  document: 'fileSize:10'
}

const dataFormEditDocument = ref<{ [key: string]: any }>({ ..._initForm })
const emits = defineEmits(['close', 'refreshDataTables'])
const visible = ref(false)
const creating = ref(false)
const fileDocument = ref<File | string | undefined>(undefined)

const orderId = ref('')

const openEditDocument = (data: any) => {
  visible.value = true
  creating.value = false

  orderId.value = data.order
  dataFormEditDocument.value.id = data._id
  dataFormEditDocument.value.fileName = data.fileName
  dataFormEditDocument.value.type = data.type
  dataFormEditDocument.value.description = data.description
  dataFormEditDocument.value.fileOriginName = data.fileOriginName
}

defineExpose({
  openEditDocument
})

const closeOverSide = () => {
  resetForm()
  visible.value = false
}

const resetForm = () => {
  fileDocument.value = undefined
  dataFormEditDocument.value = { ..._initForm }
}

const listTypeDocument = [
  {
    key: 'BOOKING',
    value: $t('labels.booking')
  },
  {
    key: 'OTHER',
    value: $t('labels.other')
  }
]

const handleSubmitFormEditDocument = async () => {
  const dataForm = new FormData()
  fileDocument.value && dataForm.append('document', fileDocument.value)
  dataForm.append('fileName', dataFormEditDocument.value.fileName || '')
  dataForm.append('type', dataFormEditDocument.value.type || '')
  dataForm.append('description', dataFormEditDocument.value.description || '')

  const api = {
    method: 'PUT',
    url: '/order/ID/document/docId'
  }
  const res: any = await $api(api, { uriParams: { ID: orderId.value, docId: dataFormEditDocument.value.id }, body: dataForm })
  const resData: any = res?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('notifications.editSuccessDocument'))
    emits('close')
    emits('refreshDataTables')
    visible.value = false
  }
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }
  return 'grid-cols-1'
})
</script>
